import cx from 'classnames'
import { Button } from 'blaze-ui/Button'
import Styles from './BrandWizardVisualAnalysisModal.module.scss'
import { Upload5 } from 'blaze-ui/icons'
import { VisuallyHidden } from '@react-aria/visually-hidden'
import { useState } from 'react'
import { useBrandWizardVisualAnalysisContext } from './BrandWizardVisualAnalysisContext'
import { useHover } from '@react-aria/interactions'
import { ButtonProps } from 'blaze-ui/Button/Types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useLoggedIn } from 'hooks/useLoggedIn'

interface Props {
  logo?: string
}

const UploadLogoButton = ({ children }: Pick<ButtonProps, 'children'>) => {
  const { result, onChange } = useBrandWizardVisualAnalysisContext()
  const [fileInputRef, setFileInputRef] = useState<HTMLInputElement | null>(null)

  const handlePress = () => {
    fileInputRef?.click()
  }

  return (
    <>
      <Button variant="secondary" size="xs" frontIcon={Upload5} onPress={handlePress}>
        {children}
      </Button>
      <VisuallyHidden>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => {
            const file = e.target.files?.[0]
            if (file) {
              onChange({
                ...result,
                logo: URL.createObjectURL(file),
                logoFile: file,
              })
            }
          }}
          ref={setFileInputRef}
          multiple={false}
          name="Upload logo"
          id="upload-logo"
          data-testid="file-input"
        />
      </VisuallyHidden>
    </>
  )
}

const EmptyState = () => {
  const loggedIn = useLoggedIn()
  return (
    <>
      <span>We couldn't find your logo</span>
      {loggedIn && <UploadLogoButton>Upload</UploadLogoButton>}
    </>
  )
}

export const Logo = ({ logo }: Props) => {
  const { isHovered, hoverProps } = useHover({})
  const { isMobile } = useResponsiveDesign()

  if (logo) {
    return (
      <div className={Styles.logo} {...hoverProps}>
        <div className={cx(Styles.logoActions, { [Styles.visible]: isHovered || isMobile })}>
          <UploadLogoButton>{isMobile ? '' : 'Change'}</UploadLogoButton>
        </div>
        <img src={logo} alt="Logo" />
      </div>
    )
  }

  return (
    <div className={cx(Styles.logo, Styles.logoEmptyState)}>
      <EmptyState />
    </div>
  )
}
